import { render, staticRenderFns } from "./MyProgramHealth.vue?vue&type=template&id=457c71ba&scoped=true"
import script from "./MyProgramHealth.vue?vue&type=script&lang=ts"
export * from "./MyProgramHealth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c71ba",
  null
  
)

export default component.exports